export const dhConfigGassHvis = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_GASS_HVIS/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "GASS_HVIS",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_GASS_HVIS_%validtime%/%z%_%y%_%x%.png?latestValid=%latestValid%",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const dhConfigGassCling = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_GASS_CLING/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "GASS_CLING",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_GASS_CLING_%validtime%/%z%_%y%_%x%.png?latestValid=%latestValid%",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

// Layer
export const layerConfigHvis = {
  "Name": "GassScaleHvis",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "alternative_color": [0, 0, 0, 0],
        "palette": [
          [0, 0, 0, 0],        // x
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100], // 10
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100], // 20
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100], // 30
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100], // 40
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 255, 0, 100], // 50
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100], // 10
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100], // 20
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100], // 30
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100], // 40
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],  // 10
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],  // 20
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],  // 30
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],
          [86, 254, 177, 0],  // 40
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0]
        ]
      }
    }
  }
};

export const layerConfigCling = {
  "Name": "GassScaleCling",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "alternative_color": [0, 0, 0, 0],
        "palette": [
          [0, 0, 0, 0],        // x
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100],
          [255, 0, 0, 100], // 4
          [255, 255, 0, 100],
          [255, 255, 0, 100],
          [255, 255, 0, 100], // 7
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100], // 10
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100], // 20
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100], // 30
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100], // 40
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100], // 50
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],
          [86, 254, 177, 100],  // 60
          [86, 254, 177, 100],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0]
        ]
      }
    }
  }
};
